export const environment = {
  production: true,
  apiUrl: 'https://api.officeops.thesoftwareguy.co.za/'
};
